import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=3acfb34f&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=3acfb34f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfb34f",
  null
  
)

export default component.exports